var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Loading from '@web/components/layout/Loading';
import StatsCard from '@web/components/ui/Stats/StatsCard';
import { trpc } from '@web/lib/trpc';
import { useFilters } from '@web/utility/hooks/useFilters';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { formatDuration, getPercentageDiff, getPreviousPeriod } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
var MeetingsStats = function () {
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var _b = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _b.prevPeriodDateFrom, prevPeriodDateTo = _b.prevPeriodDateTo;
    var data = trpc.meetingAnalytic.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    });
    var prevPeriodData = trpc.meetingAnalytic.useQuery({
        dateFrom: prevPeriodDateFrom,
        dateTo: prevPeriodDateTo,
        userId: user,
        orgUnitId: orgUnit,
        includeTeamAverage: false
    });
    if (data.isLoading || !(data === null || data === void 0 ? void 0 : data.data) || !(prevPeriodData === null || prevPeriodData === void 0 ? void 0 : prevPeriodData.data)) {
        return _jsx(Loading, {});
    }
    var _c = data.data, durationSeconds = _c.durationSeconds, dailyAvgDurationPerUser = _c.dailyAvgDurationPerUser, recurringMeetingsDuration = _c.recurringMeetingsDuration, scheduledMeetingsParticipationRate = _c.scheduledMeetingsParticipationRate, teamAverage = _c.teamAverage;
    var _d = prevPeriodData.data, prevDurationSeconds = _d.durationSeconds, prevDailyAvgDurationPerUser = _d.dailyAvgDurationPerUser, prevRecurringMeetingsDuration = _d.recurringMeetingsDuration;
    var showTeamDiff = Boolean(user);
    var durationDiffOptions = {
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds
    };
    var teamDiffOptions = {
        comparisonType: diffComparisonType.teamAverage
    };
    var stats = [
        {
            title: t('app.apps.meeting.stats.meetingsDurationHours'),
            value: formatDuration(durationSeconds, 'seconds'),
            diffValue: getPercentageDiff(prevDurationSeconds, durationSeconds, __assign({}, durationDiffOptions)),
            teamAverage: showTeamDiff && teamAverage
                ? getPercentageDiff(teamAverage.durationSeconds, durationSeconds, __assign(__assign({}, durationDiffOptions), teamDiffOptions))
                : null
        },
        {
            title: t('app.apps.meeting.stats.dailyAvgDurationPerUser'),
            value: formatDuration(dailyAvgDurationPerUser, 'seconds'),
            diffValue: getPercentageDiff(prevDailyAvgDurationPerUser, dailyAvgDurationPerUser, durationDiffOptions),
            teamAverage: showTeamDiff && teamAverage
                ? getPercentageDiff(teamAverage.dailyAvgDurationPerUser, dailyAvgDurationPerUser, __assign(__assign({}, durationDiffOptions), teamDiffOptions))
                : null
        },
        {
            title: t('app.apps.meeting.stats.recurringMeetingsDuration'),
            value: formatDuration(recurringMeetingsDuration, 'seconds'),
            diffValue: getPercentageDiff(prevRecurringMeetingsDuration, recurringMeetingsDuration, durationDiffOptions),
            teamAverage: showTeamDiff && teamAverage
                ? getPercentageDiff(teamAverage.recurringMeetingsDuration, recurringMeetingsDuration, __assign(__assign({}, durationDiffOptions), teamDiffOptions))
                : null
        },
        {
            title: t('app.apps.meeting.stats.scheduledMeetingsParticipation'),
            value: "".concat(scheduledMeetingsParticipationRate, "%"),
            diffValue: null,
            teamAverage: showTeamDiff && teamAverage
                ? getPercentageDiff(teamAverage.scheduledMeetingsParticipationRate, scheduledMeetingsParticipationRate, teamDiffOptions)
                : null
        }
    ];
    return _jsx(StatsCard, { stats: stats });
};
export default MeetingsStats;
